// // src/context/UserContext.js
// import React, { createContext, useState } from 'react';
// export const UserContext = createContext();
// export function UserProvider({ children }) {
//   // Existing state variables
//   const [segmentName, setSegmentName] = useState(null);
//   const [customerName, setCustomerName] = useState(null);
//   const [agentStrategy, setAgentStrategy] = useState(null);
//   const [customerNeeds, setCustomerNeeds] = useState(null);
//   const [gptOutputs, setGptOutputs] = useState(null);
//   // Added state variables
//   const [selectedProducts, setSelectedProducts] = useState([]);
//   const [selectedProductCodes, setSelectedProductCodes] = useState([]);
//   const [pitchResponse, setPitchResponse] = useState('');
//   // State for AgentStrategy page to preserve form data
//   const [agentStrategyState, setAgentStrategyState] = useState({
//     strategy: '1',
//     recommendationType: '1.1',
//     productOption: 'All',
//     selectedProducts: [],
//   });
//   // State for CustomerSegmentation and ProductRecommendation pages
//   const [productRecommendationFormData, setProductRecommendationFormData] = useState({
//     customerName: '',
//     customerAge: '',
//     gender: 'Male', // Default gender
//     customerIncome: '',
//     dependents: '',
//     primaryGoals: [],
//     childEducationAmount: '',
//     childEducationTimeframe: '',
//     wealthCreationAmount: '',
//     wealthCreationTimeframe: '',
//     marriageHouseAmount: '',
//     marriageHouseTimeframe: '',
//     secondaryGoals: [],
//     investmentTimeline: '',
//     returnExpectation: '',
//     riskTolerance: '',
//     lifeStage: '',
//     specificEvents: [],
//     specificChildEducationAmount: '',
//     specificChildEducationTimeframe: '',
//     additionalInfo: '',
//   });
//   const [recommendations, setRecommendations] = useState({
//     assessment_response: '',
//     single_product_recommendation: '',
//     product_mix_recommendation: '',
//   });
//   const [segmentData, setSegmentData] = useState(null); // Default to null
//   // State for storing user inputs and LLM outputs from the EBI page
//   const [ebiUserInputs, setEbiUserInputs] = useState({}); // { productCode: userInputs }
//   const [ebiLLMOutputs, setEbiLLMOutputs] = useState({}); // { productCode: llmOutput }
//   const [ebiOutputs, setEbiOutputs] = useState({}); // { productCode: ebiOutput }
//   const [ebiExplanations, setEbiExplanations] = useState({}); // { productCode: explanation }
//   const [comparisonOutput, setComparisonOutput] = useState(''); // Added for product comparison
//   const [productDetails, setProductDetails] = useState({}); // Added to hold product names and codes
//   const [combinedEbiData, setCombinedEbiData] = useState({}); // Added to hold the comparision output
//   const [summary, setSummary] = useState('');
//   return (
//     <UserContext.Provider
//       value={{
//         segmentName,
//         setSegmentName,
//         customerName,
//         setCustomerName,
//         agentStrategy,
//         setAgentStrategy,
//         customerNeeds,
//         setCustomerNeeds,
//         gptOutputs,
//         setGptOutputs,
//         selectedProducts,
//         setSelectedProducts,
//         selectedProductCodes,
//         setSelectedProductCodes,
//         pitchResponse,
//         setPitchResponse,
//         agentStrategyState,
//         setAgentStrategyState,
//         productRecommendationFormData,
//         setProductRecommendationFormData,
//         recommendations,
//         setRecommendations,
//         segmentData,
//         setSegmentData,
//         ebiUserInputs,
//         setEbiUserInputs,
//         ebiLLMOutputs,
//         setEbiLLMOutputs,
//         ebiOutputs,
//         setEbiOutputs,
//         ebiExplanations,
//         setEbiExplanations,
//         comparisonOutput,
//         setComparisonOutput,
//         productDetails,
//         combinedEbiData,
//         setCombinedEbiData,
//         setProductDetails,
//         summary,
//         setSummary,
//       }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// }


// // src/context/UserContext.js
// import React, { createContext, useState } from 'react';
// export const UserContext = createContext();
// export function UserProvider({ children }) {
//   const [segmentName, setSegmentName] = useState(null);
//   const [customerName, setCustomerName] = useState(null);
//   const [agentStrategy, setAgentStrategy] = useState({
//     strategy: '1',
//     recommendation_type: '1.1',
//     product_option: 'All',
//     selected_products: [],
//     recommendationType: '1.1',
//   });
//   const [userNTID, setUserNTID] = useState(null); // this is added new for storing the ntid
//   const [userChannel, setUserChannel] = useState(null);// this is added new for storing the channel
//   const [customerNeeds, setCustomerNeeds] = useState(null);
//   const [gptOutputs, setGptOutputs] = useState(null);
//   const [selectedProducts, setSelectedProducts] = useState([]);
//   const [selectedProductCodes, setSelectedProductCodes] = useState([]);
//   const [pitchResponse, setPitchResponse] = useState('');
//   const [agentStrategyState, setAgentStrategyState] = useState({
//     strategy: '1',
//     recommendationType: '1.1',
//     productOption: 'All',
//     selectedProducts: [],
//   });
//   const [productRecommendationFormData, setProductRecommendationFormData] = useState({
//     customerName: '',
//     customerAge: '',
//     gender: 'Male',
//     customerIncome: '',
//     dependents: '',
//     primaryGoals: [],
//     childEducationAmount: '',
//     childEducationTimeframe: '',
//     wealthCreationAmount: '',
//     wealthCreationTimeframe: '',
//     marriageHouseAmount: '',
//     marriageHouseTimeframe: '',
//     secondaryGoals: [],
//     investmentTimeline: '',
//     returnExpectation: '',
//     riskTolerance: '',
//     lifeStage: '',
//     specificEvents: [],
//     specificChildEducationAmount: '',
//     specificChildEducationTimeframe: '',
//     additionalInfo: '',
    
//   });
//   const [recommendations, setRecommendations] = useState({
//     assessment_response: '',
//     single_product_recommendation: '',
//     product_mix_recommendation: '',
//   });
//   const [segmentData, setSegmentData] = useState(null);
//   const [ebiUserInputs, setEbiUserInputs] = useState({});
//   const [ebiLLMOutputs, setEbiLLMOutputs] = useState({});
//   const [ebiOutputs, setEbiOutputs] = useState({});
//   const [ebiExplanations, setEbiExplanations] = useState({});
//   const [comparisonOutput, setComparisonOutput] = useState('');
//   const [productDetails, setProductDetails] = useState({});
//   const [combinedEbiData, setCombinedEbiData] = useState({});
//   const [summary, setSummary] = useState('');
//   const [userChoiceForAIProducts, setUserChoiceForAIProducts] = useState('AI');
//   const [aiRecommendedParsedData, setAiRecommendedParsedData] = useState('');
//   return (
//     <UserContext.Provider
//       value={{
//         segmentName,
//         setSegmentName,
//         customerName,
//         setCustomerName,
//         agentStrategy,
//         setAgentStrategy,
//         customerNeeds,
//         setCustomerNeeds,
//         gptOutputs,
//         setGptOutputs,
//         selectedProducts,
//         setSelectedProducts,
//         selectedProductCodes,
//         setSelectedProductCodes,
//         pitchResponse,
//         setPitchResponse,
//         agentStrategyState,
//         setAgentStrategyState,
//         productRecommendationFormData,
//         setProductRecommendationFormData,
//         recommendations,
//         setRecommendations,
//         segmentData,
//         setSegmentData,
//         ebiUserInputs,
//         setEbiUserInputs,
//         ebiLLMOutputs,
//         setEbiLLMOutputs,
//         ebiOutputs,
//         setEbiOutputs,
//         ebiExplanations,
//         setEbiExplanations,
//         comparisonOutput,
//         setComparisonOutput,
//         productDetails,
//         setProductDetails,
//         combinedEbiData,
//         setCombinedEbiData,
//         summary,
//         setSummary,
//         userChoiceForAIProducts,
//         setUserChoiceForAIProducts,
//         aiRecommendedParsedData,
//         setAiRecommendedParsedData,
//         userNTID,
//         setUserNTID,
//         userChannel,
//         setUserChannel,
//       }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// }

// src/context/UserContext.js
import React, { createContext, useState } from 'react';
export const UserContext = createContext();
export function UserProvider({ children }) {
  const [segmentName, setSegmentName] = useState(null);
  const [customerName, setCustomerName] = useState(null);
  const [agentStrategy, setAgentStrategy] = useState({
    strategy: '1',
    recommendation_type: '1.1',
    product_option: 'All',
    selected_products: [],
    recommendationType: '1.1',
  });
  // const [userNTID, setUserNTID] = useState(null); // storing the ntid
  const [userNTID, setUserNTID] = useState(null); // storing the ntid
  const [userChannel, setUserChannel] = useState(null); // storing the channel
  const [customerNeeds, setCustomerNeeds] = useState(null);
  const [gptOutputs, setGptOutputs] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductCodes, setSelectedProductCodes] = useState([]);
  const [pitchResponse, setPitchResponse] = useState('');
  // This is the "front-end only" state for user selections
  const [agentStrategyState, setAgentStrategyState] = useState({
    strategy: '1',
    recommendationType: '1.1',
    productOption: 'All',
    selectedProducts: [],
  });
  /**
   * Updated productRecommendationFormData to include new fields for:
   *  - getBenefitsAs (Income/Lumpsum)
   *  - lumpsumTimeline
   *  - lumpsumAmount
   *  - incomeStartYear
   *  - incomeTerm
   *  - incomeAmountPa
   *  - riskProfile (Conservative/Moderate/Aggressive)
   */
  const [productRecommendationFormData, setProductRecommendationFormData] = useState({
    // NEW fields:
    getBenefitsAs: 'Income',      // toggle default
    lumpsumTimeline: 5,          // default minimum
    lumpsumAmount: '',
    incomeStartYear: 1,
    incomeTerm: 5,
    incomeAmountPa: '',
    riskProfile: 'Conservative', // radio default
    // OLD fields (placeholders to satisfy existing APIs):
    additionalInfo: '',
    customerName: '',
    customerAge: '',
    gender: 'Male',
    customerIncome: '',
    dependents: '',
    // primaryGoals: [],
    // childEducationAmount: '',
    // childEducationTimeframe: '',
    // wealthCreationAmount: '',
    // wealthCreationTimeframe: '',
    // marriageHouseAmount: '',
    // marriageHouseTimeframe: '',
    // secondaryGoals: [],
    // investmentTimeline: '',
    // returnExpectation: '',
    // riskTolerance: '',
    // lifeStage: '',
    // specificEvents: [],
    // specificChildEducationAmount: '',
    // specificChildEducationTimeframe: '',
    // policyTerm: '',
    // premiumPaymentTerm: '',
  });
  const [recommendations, setRecommendations] = useState({
    assessment_response: '',
    single_product_recommendation: '',
    product_mix_recommendation: '',
  });
  const [segmentData, setSegmentData] = useState(null);
  // EBI related states
  const [ebiUserInputs, setEbiUserInputs] = useState({});
  const [ebiLLMOutputs, setEbiLLMOutputs] = useState({});
  const [ebiOutputs, setEbiOutputs] = useState({});
  const [ebiExplanations, setEbiExplanations] = useState({});
  const [comparisonOutput, setComparisonOutput] = useState('');
  const [productDetails, setProductDetails] = useState({});
  const [combinedEbiData, setCombinedEbiData] = useState({});
  const [summary, setSummary] = useState('');
  // AI recommendation parsing / product selection approach
  const [userChoiceForAIProducts, setUserChoiceForAIProducts] = useState('AI');
  const [aiRecommendedParsedData, setAiRecommendedParsedData] = useState('');
  return (
    <UserContext.Provider
      value={{
        segmentName,
        setSegmentName,
        customerName,
        setCustomerName,
        agentStrategy,
        setAgentStrategy,
        customerNeeds,
        setCustomerNeeds,
        gptOutputs,
        setGptOutputs,
        selectedProducts,
        setSelectedProducts,
        selectedProductCodes,
        setSelectedProductCodes,
        pitchResponse,
        setPitchResponse,
        agentStrategyState,
        setAgentStrategyState,
        productRecommendationFormData,
        setProductRecommendationFormData,
        recommendations,
        setRecommendations,
        segmentData,
        setSegmentData,
        ebiUserInputs,
        setEbiUserInputs,
        ebiLLMOutputs,
        setEbiLLMOutputs,
        ebiOutputs,
        setEbiOutputs,
        ebiExplanations,
        setEbiExplanations,
        comparisonOutput,
        setComparisonOutput,
        productDetails,
        setProductDetails,
        combinedEbiData,
        setCombinedEbiData,
        summary,
        setSummary,
        userChoiceForAIProducts,
        setUserChoiceForAIProducts,
        aiRecommendedParsedData,
        setAiRecommendedParsedData,
        userNTID,
        setUserNTID,
        userChannel,
        setUserChannel,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}